import { ReactNode } from "react";
import Box from "@mui/material/Box";
import Grid, { GridBaseProps } from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

const DEFAULT_SIZE: GridBaseProps["size"] = { xs: 12, sm: 6, lg: 3 };

interface FilterFieldProps {
  label: string;
  /** Grid width of the label + control pair. Widen it for controls that need more room. */
  size?: GridBaseProps["size"];
  children: ReactNode;
}

/**
 * One labelled control in the product / pricebook filter bars.
 *
 * The label takes only the width of its own text and the control takes the rest, so a
 * short label such as "สถานะ" does not leave a gap between itself and its input.
 */
export default function FilterField({
  label,
  size = DEFAULT_SIZE,
  children,
}: FilterFieldProps) {
  return (
    <Grid size={size}>
      <Stack direction="row" alignItems="center" gap={1}>
        <Typography variant="body2" noWrap>
          {label}
        </Typography>
        <Box sx={{ flexGrow: 1, minWidth: 0 }}>{children}</Box>
      </Stack>
    </Grid>
  );
}
